export default function setCurrentSetting(state, payload) {
  const { canTravel, itemsUsableHere } = payload;
  return {
    ...state,
    canTravel,
    itemsUsableHere,
  };
}